<template>
  <div class="mb-6">

    <div class="columns is-multiline">
      <div class="column is-12-mobile is-2-tablet">
        <InputText :hasIconSearch="true" name="Nome" v-model="filters.name" @input="onFilterInput" />
      </div>
      <div class="column is-12-mobile is-2-tablet">
        <InputText :hasIconSearch="true" name="Indirizzo" v-model="filters.address" @input="onFilterInput" />
      </div>
      <div class="column is-12-mobile is-2-tablet">
        <InputText :hasIconSearch="true" name="Telefono" v-model="filters.telephone" @input="onFilterInput" />
      </div>
      <div class="column is-12-mobile is-2-tablet">
        <InputText :hasIconSearch="true" name="P. Iva" v-model="filters.vat" @input="onFilterInput" />
      </div>
      <div class="column is-12-mobile is-2-tablet">
        <InputText :hasIconSearch="true" name="Note" v-model="filters.notes" @input="onFilterInput" />
      </div>
      <div class="column is-12-mobile is-2-tablet">
        <InputSelect
          name="Installatore"
          v-model="filters.isInstaller"
          @select="onFilterInput"
          @remove="onFilterInput"
          :options="[{'label': 'Sì', value: true}, {'label': 'No', value: false}]"
          id="value"
          track-by="value"
          label="label"
        />
      </div>
      <div class="column is-12-mobile is-4-tablet">
        <label class="label">&nbsp;</label>
        <div class="buttons is-flex">
          <button class="button" @click="resetFilters()"><font-awesome-icon icon="filter-circle-xmark" />Reset</button>
          <router-link to="/clienti/new" class="button is-primary is-hidden-touch" @click="resetFilters()"><font-awesome-icon icon="plus" />Aggiungi</router-link>
        </div>
      </div>
    </div>

    <div class="b-table has-pagination" :class="{'is-loading': loading}">
      <div class="table-wrapper has-mobile-cards">
        <table class="table is-fullwidth is-striped is-hoverable">
          <thead>
          <tr>
            <th>Nome</th>
            <th>Indirizzo</th>
            <th>Telefono</th>
            <th>P. Iva</th>
            <th>Installatore</th>
            <th style="width: 190px;">Luoghi</th>
            <th>Impianti</th>
            <th>Note</th>
            <th style="min-width: 100px;"></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(client, index) in clients" :key="index">
            <td data-label="Nome">
              <ClientHeading :client="client" :showIcons="true" />
            </td>
            <td data-label="Indirizzo">
              <AddressDisplay :value="client" />
            </td>
            <td data-label="Telefono">
              <div>
                <div v-for="(contact, index) in client.contacts" :key="index">
                  <div v-if="contact.telephone" class="is-flex is-align-items-center" :class="{'mt-2': index}">
                    <div class="mr-2" style="width: 110px; font-size: 0.9rem;">
                      <div>{{contact.name}}</div>
                      <div>{{contact.telephone}}</div>
                    </div>
                    <a class="button is-warning is-small" :href="contact.telephone ? 'tel:'+contact.telephone : ''">
                      <font-awesome-icon icon="phone" class="m-0" />
                    </a>
                  </div>
                </div>
              </div>
            </td>
            <td data-label="P. Iva">
              <div>
                {{client.vat}}
              </div>
            </td>
            <td data-label="Installatore">
              <span v-if="client.isInstaller" class="tag is-success">Sì</span>
            </td>
            <td data-label="Luoghi">
              <div class="tags">
                <span class="tag is-info" v-for="(place, index) in client.places" :key="index">
                  <router-link class="has-text-white" :to="'/luoghi/' + place._id" v-html="$placeName(place) || '<i>Nessun nome</i>'"></router-link>
                </span>
              </div>
            </td>
            <td data-label="Impianti">
              <!--<div class="tags">
                <span :class="['tag', {'is-orange': implant.occupant !== client._id}, {'is-info': implant.occupant === client._id}]" v-for="(implant, index) in client.implants" :key="index">
                  <router-link class="has-text-white" :to="'/impianti/' + implant._id" v-html="$implantName(implant) || '<i>Nessun nome</i>'"></router-link>
                </span>
              </div>-->
              <div>
                <router-link class="tags-container" v-for="(implant, index) in client.implants" :key="index" :to="'/impianti/' + implant._id">
                  <div class="tags has-addons">
                    <span class="tag is-dark" v-if="implant.occupant?._id !== client._id">{{$clientName(implant.occupant)}}</span>
                    <span :class="['tag has-text-white', {'is-orange': implant.occupant?._id !== client._id}, {'is-info': implant.occupant?._id === client._id}]" v-html="$implantName(implant) || '<i>Nessun nome</i>'"></span>
                  </div>
                </router-link>
              </div>
            </td>
            <td data-label="Note">
              <InfoButton :text="client.notes" />
            </td>
            <td class="is-actions-cell is-justify-content-flex-end">
              <div class="buttons is-right">
                <router-link :to="'/clienti/' + client._id" class="button is-warning" type="button" title="Modifica" :disabled="client.waitDelete">
                  <span class="icon"><font-awesome-icon icon="pen" /></span>
                </router-link>
                <button class="button is-danger" type="button" @click="deleteClient(client)" title="Elimina" :class="[{'is-loading': client.waitDelete}]" :disabled="client.waitDelete">
                  <span class="icon"><font-awesome-icon icon="trash-can" /></span>
                </button>
              </div>
            </td>
          </tr>
          <tr v-if="clients.length === 0">
            <td colspan="100" class="has-text-centered has-text-grey">
              <i>Nessun risultato</i>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <Pagination :pagination="pagination" @change="getClients($event)" />
    </div>

    <router-link to="/clienti/new" class="button is-floating is-primary is-hidden-desktop" title="Nuovo">
      <span class="icon">
        <font-awesome-icon icon="plus" />
      </span>
    </router-link>

  </div>
</template>

<script>
import AddressDisplay from '../components/AddressDisplay.vue'

export default {
  components: {
    AddressDisplay
  },

  data() {
    return {
      filters: this.$store.state.filters.client,

      clients: [],

      pagination:{
        total: false,
        selected: false
      },

      loading: true
    }
  },

  methods: {
    resetFilters() {
      this.filters = {}

      this.getClients()
    },

    getClients(args = {page: 1, size: 30, scroll: 0}) {
      const self = this
      
      this.loading = true

      this.$store.commit('setFilter', {name: 'client', value: this.filters})
      this.$store.commit('setPage', {name: 'client', value: {number: args.page, size: args.size}})

      const isInstaller = this.filters.isInstaller ? this.filters.isInstaller.value : null

      this.$http.get('/client', { params: {
        page: args.page,
        size: args.size,
        ...this.filters,
        isInstaller
      } }).then(response => {
        if (response && response.data) {
          this.clients = response.data.records
          this.pagination = {
            total: response.data.totalRecords,
            pages: response.data.totalPages,
            selected: response.data.currentPage
          }

          if (args.scroll) {
            self.$nextTick(() => {
              window.scroll(0, args.scroll)
            })
          }
        }

        this.loading = false
      })
      .catch(function (error) {
        console.log(error)
        alert('Errore')
        self.loading = false
      })
    },

    deleteClient(client) {
      if (confirm('Eliminare?')) {
        const self = this
        client.waitDelete = true

        this.$http.delete('/client/' + client._id)
        .then(function (response) {
          self.getClients({page: self.$store.state.pages.client.number, size: self.$store.state.pages.client.size})
        })
        .catch(function (error) {
          console.log(error)
          alert('Errore')
          client.waitDelete = false
        })
      }
    }
  },

  mounted() {
    this.getClients({page: this.$store.state.pages.client.number, size: this.$store.state.pages.client.size, scroll: this.$store.state.pages.client.scroll})
  },

  created() {
    this.onFilterInput = this.$debounce(() => this.getClients(), 500)
  },

  beforeUnmount() {
    const scroll = window.top.scrollY
    let page = Object.assign({}, this.$store.state.pages.client)
    page.scroll = scroll
    this.$store.commit('setPage', {name: 'client', value: page})
  }
}
</script>